<template>
  <li :class="decorated.status_text === 'Cancelled' ? 'load-cancelled' : load.day">
    <div class="row">
      <div class="col-xs-2 col-sm-2  col-md-1">
        <p class="load-number">{{ number }}</p>
      </div>
      <div class="col-xs-10 col-sm-10 col-md-11">
        <p class="load-reference">
          {{ decorated.reference_number }}
          <span class="load-status pull-right" :class="decorated.status_class">{{ decorated.status_text }}</span>
        </p>
      </div>
      <div class="col-xs-12 col-sm-offset-2 col-sm-10 col-md-offset-1 col-md-11">
        <div class="row">
          <div class="col-xs-12"></div>
        </div>

        <div class="row">
          <div class="col-xs-6 col-md-4 col-lg-2">
            <p>
              <strong>Loading Date</strong><br />
              {{ decorated.loading_date }}
            </p>
          </div>
          <div class="col-xs-6 col-md-4 col-lg-2">
            <p>
              <strong>Loading Time</strong><br />
              {{ decorated.loading_time }}
            </p>
          </div>
          <div class="col-xs-6 col-md-4 col-lg-2">
            <p>
              <strong>Weighbridge Details</strong><br />

              <a
                v-if="haveWeighbridge"
                @click="setActiveLoad"
                data-toggle="modal"
                data-target=".modal-load-check">
                View <i class="fa fa-external-link-square"></i>
              </a>
              <span v-else>&ndash;</span>
            </p>
          </div>
          <div class="col-xs-6 col-md-4 col-lg-2">
            <p>
              <strong>Net Weight</strong><br />
              {{ decorated.net_weight }}
            </p>
          </div>
          <div class="col-xs-6 col-md-4 col-lg-2">
            <p>
              <strong>Rate</strong><br />
              {{ $user.isCarrierOrDriver ? decorated.rate : jobDecorated.rate  }}
            </p>
          </div>
          <div class="col-xs-6 col-md-4 col-lg-2">
            <p class="load-cost">
              <strong>Load Cost</strong><br />
              {{ clientChargeAsMoney }}
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12 col-sm-8 col-lg-6">
            <p class="material-details">
              <strong>Driver Notes</strong><br>
              {{ load.notes }}
            </p>
          </div>
          <div class="col-xs-6 col-md-4 col-lg-2">
            <p class="material-details">
              <strong>Dockets</strong><br>
              <span v-html="dockets ? dockets : '–'"></span>
            </p>
          </div>
        </div>

        <ul class="details">
          <li><span>Rego:</span> {{ decorated.registration }}</li>
          <li><span>Load Size:</span> {{ decorated.size }}</li>
        </ul>
      </div>
    </div>

    <hr v-if="load.charges.length" class="m-t-sm m-b-sm">

    <div class="row" v-if="haveCharges">
      <div class="col-sm-offset-2 col-sm-10 col-md-offset-1 col-md-11">

        <charge v-for="charge in load.charges" :key="charge.id" :charge="charge" :load="load"></charge>
      </div>
    </div>
  </li>
</template>

<script>
  import { loadHelpers } from 'mixins/loads'
  import Charge from './Charge'
  import { mapGetters } from 'vuex'

  export default {
    mixins: [loadHelpers],

    components: {
      Charge
    },

    props: ['load', 'index'],

    computed: {
      ...mapGetters('job', ['jobDecorated'])
    }
  }
</script>



// WEBPACK FOOTER //
// ClientLoad.vue?ed1d519c